import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("leo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Post-logout guard: stale requests fired by unmounted components after
// logout return 401. Those are expected — surface them silently instead of
// bubbling into React's Uncaught runtime errors overlay on /login.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const hasToken = !!localStorage.getItem("leo_token");
    if (status === 401 && hasToken) {
      // Session expired: the stored token is stale/invalid. Clear it and
      // send the user back to login silently instead of letting the 401
      // reject and bubble up into the runtime error overlay.
      localStorage.removeItem("leo_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
      return Promise.resolve({ data: null, status: 401, __sessionExpired: true });
    }
    if (status === 401 && !hasToken) {
      // Return a fake resolved response so callers that don't handle
      // rejections don't crash the app.
      return Promise.resolve({ data: null, status: 401, __postLogout: true });
    }
    return Promise.reject(err);
  },
);

export default api;
